import styled from '@emotion/styled';

export const ContainerSC = styled.div`
  padding: 24px;
  border-radius: 8px;
  background: white;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const TextSC = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  margin: 10px 0 16px;
`;
